import axios, { AxiosResponse } from 'axios';
import * as React from 'react';
import MiddlewareEventBus from '../../react/common/lib/MiddlewareEventBus';
import { ISearchResponse, IStoreConfig } from '../../shop-ui/components/search-page/interfaces';
import { IProductItem } from '../../shop-ui/interfaces';
import { ProductSliderEvent } from '../events';
import { ISliderContainerProps, ISliderDataUpdatedPayload, ISliderProps } from '../interfaces';

type HighOrderComponent<T> = (Component: React.FunctionComponent) => React.FunctionComponent<T>;

export function withAPI(defaultMinimumItemForDisplay: number): HighOrderComponent<ISliderProps> {
    function withAPIComponent(FunctionComponent: React.FunctionComponent<ISliderContainerProps>): React.FunctionComponent<ISliderProps> {
        const wrappedComponent: React.FunctionComponent<ISliderProps> = props => {
            const { apiUrl, minimumItemForDisplay, skeletonName, useLazyLoad } = props;

            const [isLoaded, setLoaded] = React.useState<boolean>(false);
            const [items, setItems] = React.useState<IProductItem[]>([]);
            const [storeConfig, setStoreConfig] = React.useState<IStoreConfig>(null);

            const onComponentRendered = () => {
                axios.get(apiUrl.toString()).then((result: AxiosResponse<ISearchResponse>) => {
                    MiddlewareEventBus.getInstance().publish<ISliderDataUpdatedPayload>(
                        {
                            type: ProductSliderEvent.PRODUCT_SLIDER_DATA_UPDATED,
                            payload: {
                                skeletonName,
                            },
                        },
                    );

                    setLoaded(true);
                    setItems(result.data.resultItems as IProductItem[]);
                    setStoreConfig(result.data.storeConfig);
                });
            };

            React.useEffect(onComponentRendered, []);

            const minItemForDisplay = !minimumItemForDisplay ? defaultMinimumItemForDisplay : minimumItemForDisplay;

            if (false === isLoaded || items.length < minItemForDisplay) {
                return null;
            }

            return <FunctionComponent items={items} storeConfig={storeConfig} {...props} />;
        };

        wrappedComponent.displayName = 'withAPI';

        return wrappedComponent;
    }

    return withAPIComponent;
}
